import { FirstName } from '@dreryk/person-name-common-api';

import { commonTranslationKeys, FieldControllerProps } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

type FirstNameFieldProps = FieldControllerProps<'firstName', string | null>;

export const FirstNameField = (props: FirstNameFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register(props.name, {
            required: props.required,
            maxLength: FirstName.MAX_LENGTH,
         })}
         label={commonTranslationKeys.firstName}
         testId={props.name}
         defaultValue={props.defaultValue}
      />
   );
};
